const _FSH = 'FSH',
  _FBP = 'FBP',
  _3DIV = '3DIV',
  _PEARL = 'PEARL',
  _WFJ = 'WFJ',
  _TOTAL = 'TOTAL',
  _MEITU = 'MEITU',
  _TOTAL_MONTHS = 'Total/Month',
  _BUG = 'BUG',
  _CODE_SMELL = 'CODE_SMELL',
  _VULNERABILITY = 'VULNERABILITY',
  _CRITICAL = 'CRITICAL',
  _MAJOR = 'MAJOR',
  _MINOR = 'MINOR',
  _BLOCKER = 'BLOCKER',
  DIVISIONS = ['FSH', 'FBP', '3DIV', 'WFJ', 'MEITU'],
  COLORS = {
    FSH: 'rgb(151, 210, 236)',
    FBP: 'rgb(236, 114, 114)',
    '3DIV': 'rgb(39, 123, 192)',
    WFJ: 'rgb(214, 228, 229)',
    MEITU: 'rgb(78,186,114)',
    'Total/Month': 'rgb(252, 191, 73)'
  };

export default {
  _FSH,
  _FBP,
  _3DIV,
  _PEARL,
  _WFJ,
  _MEITU,
  _TOTAL,
  _TOTAL_MONTHS,
  _BUG,
  _CODE_SMELL,
  _VULNERABILITY,
  _CRITICAL,
  _MAJOR,
  _MINOR,
  _BLOCKER,
  DIVISIONS,
  COLORS
};
